const WEEKDAYS_LONG = {
  en: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  et: [
    'Pühapäev',
    'Esmaspäev',
    'Teisipäev',
    'Kolmapäev',
    'Neljapäev',
    'Reede',
    'Laupäev',
  ],
};

const WEEKDAYS_SHORT = {
  en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  et: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
};

const MONTHS = {
  en: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  et: [
    'jaanuar',
    'veebruar',
    'märts',
    'aprill',
    'mai',
    'juuni',
    'juuli',
    'august',
    'september',
    'oktoober',
    'november',
    'detsember',
  ],
};

const FIRST_DAY = {
  en: 0,
  et: 1,
};

const formatDay = (d, locale = 'et') =>
  `${WEEKDAYS_LONG[locale][d.getDay()]}, ${d.getDate()} ${
    MONTHS[locale][d.getMonth()]
  } ${d.getFullYear()}`;

const formatMonthTitle = (d, locale = 'et') =>
  `${MONTHS[locale][d.getMonth()]} ${d.getFullYear()}`;

const formatWeekdayShort = (i, locale = 'et') => WEEKDAYS_SHORT[locale][i];

const formatWeekdayLong = (i, locale = 'et') => WEEKDAYS_SHORT[locale][i];

const getFirstDayOfWeek = (locale = 'et') => FIRST_DAY[locale];

export default {
  formatDay,
  formatMonthTitle,
  formatWeekdayShort,
  formatWeekdayLong,
  getFirstDayOfWeek,
};
